import { useState } from "react"
import img1 from "../assets/WhatsApp Image 2023-09-09 at 10.01.32 AM (2).jpeg"
import { Link } from "react-router-dom"
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa"



const TeamComponent = ({ team, i }) => {
    
    const [images, setImages] = useState([img1, img1, img1, img1, img1])
    const [readMore, setReadMores] = useState(false)



    return (
        <>
            <div className="animate__animated animate__fadeInLeft animate__delay-1s border-t flex justify-normal lg:flex-row md:flex-row sm:flex-col flex-wrap mb-4" >

                <div className="lg:w-[30%] md:w-[30%] sm:w-[100%]   lg:my-6 md:my-6 sm:my-2 h-[400px]  px-2 py-2 ">
                    <img
                        src={images[i]}
                        alt="team photos"
                        className="h-[400px] w-full max-w-full max-h-full  object-cover rounded-md bg-gray-50"
                    />
                </div>

                <div className="lg:w-[70%] md:w-[70%] sm:w-[100%]   py-6 px-2">
                    <h1 className="text-[24px] font-bold py-2 px-2">{team?.role}</h1>
                    <p className=" px-2 text-[16px] font-normal">
                        <b className="text-[16px]">
                            {team?.fullname}
                        </b>
                        <br />
                        {readMore ? (
                            <>
                                {team?.desc}
                            </>
                        ) : (
                            <>
                                {team?.desc.substring(0, 660)}...
                            </>
                        )}
                    </p>

                    <p className="px-2 py-1">
                        {!readMore ? (
                            <span onClick={() => { setReadMores(true) }} className="text-blue-800 font-semibold cursor-pointer">More</span>
                        ) : (
                            <span onClick={() => { setReadMores(false) }} className="text-blue-800 font-semibold cursor-pointer">Less</span>
                        )}
                    </p>

                    <div className="flex gap-4 align-middle items-center py-4 px-2">

                        <Link to={`https://www.facebook.com/`} target="_blank">
                            <FaFacebook size={24} className="text-blue-600" />
                        </Link>


                        <Link to={`https://www.twitter.com/`} target="_blank">
                            <FaTwitter size={24} className="text-blue-600" />
                        </Link>


                        <Link to={`https://www.instagram.com/`} target="_blank">
                            <FaInstagram size={24} className="text-red-600" />
                        </Link>


                        <Link to={`https://www.linkedin.com/`} target="_blank">
                            <FaLinkedin size={24} className="text-blue-600" />
                        </Link>

                    </div>

                </div>

            </div>
        </>
    )
}

export default TeamComponent